import { Spin } from 'antd';

const MapViewSearchLoading = () => {
  return (
    <div className='absolute top-2 right-2'>
      <Spin />
    </div>
  );
};

export default MapViewSearchLoading;
